<template>
  <div class="container-page" v-if="item">
    <p class="title-inner">Карточка экспортного потенциала по услугам</p>

    <template v-if="isAccessAllowed">
      <div class="row">
        <div class="form-group col-6 required">
          <ComponentInput
            label="Вид услуги"
            :select2Options="serviceList"
            v-model="item.serivceTypeId"
            :select2Settings="select2SettingsNoClear"
            type="select2"
            required
          />
        </div>
      </div>

      <div class="row">
        <div class="form-group col-6 required">
          <ComponentInput label="Потенциал прироста, млн $ США" v-model="item.value" type="number" required />
        </div>
        <div class="form-group col-6 required">
          <ComponentInput label="Фактический потенциал, $ США" v-model="item.exportValue" type="number" required />
        </div>
      </div>

      <div class="row">
        <div class="form-group col-6 required">
          <ComponentInput
            label="Страна-экспортер"
            :select2Options="countries"
            v-model="item.fromCountryId"
            :select2Settings="select2SettingsNoClear"
            type="select2"
            readonly
          />
        </div>
        <div class="form-group col-6 required">
          <ComponentInput
            label="Страна-импортер"
            :select2Options="countries"
            v-model="item.toCountryId"
            :select2Settings="select2SettingsNoClear"
            type="select2"
            required
          />
        </div>
      </div>
      <div class="mb-16">
        <ButtonComponent class="mr-8" mod="gradient-bg" buttonType="button" @click="save">Сохранить</ButtonComponent>
        <ButtonComponent mod="border" buttonType="button" @click="close">Отмена</ButtonComponent>
      </div>
    </template>
  </div>
</template>

<script>
  import { useVuelidate } from '@vuelidate/core';

  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';
  import Constants from '@/common/constants';
  import security from '@/common/mixins/security';

  import CountryApi from '@/modules/nsi/api/country';

  import ComponentInput from '../../../common/components/ComponentInput.vue';
  import Api from '../api/exportPotentialService.js';

  const PERMISSIONS = {
    create: Constants.Permissions.ExportPotentialServicesCreate,
    edit: Constants.Permissions.ExportPotentialServicesEdit,
  };

  export default {
    name: 'ExportPotentialServiceCard',
    components: { ComponentInput, ButtonComponent },
    mixins: [security],
    data() {
      return {
        id: this.$route.params.id,
        item: {
          serviceId: null,
          fromCountryId: 235,
          toCountryId: null,
        },
        countries: [],
        serviceList: [],
        select2SettingsNoClear: Constants.select2SettingsNoClear,
      };
    },
    created() {
      const accessPermission = Number(this.id) > 0 ? PERMISSIONS.edit : PERMISSIONS.create;
      this.checkPermissionAndRedirect(accessPermission).then((isAllowed) => {
        if (!isAllowed) return;

        this.loadDictionaries();
        this.loadCard();
      });
    },
    methods: {
      loadCard() {
        if (this.id > 0) {
          Api.find(this.id).then((response) => {
            this.item = response.data;
          });
        }
      },
      loadDictionaries() {
        CountryApi.getList().then((response) => {
          this.countries = response.data;
        });
        Api.getServiceList().then((response) => {
          this.serviceList = response.data.map((x) => {
            return { text: x.name, id: x.id };
          });
        });
      },
      save() {
        this.v$.$touch();
        if (this.v$.$invalid) {
          Constants.alert.fire('Ошибка', 'Проверьте правильность заполнения полей', 'error');
          return;
        }

        Api.update(this.id, this.item)
          .then(() => {
            Constants.alert.fire('Сохранение', Constants.commonSuccess, 'success');
            this.$router.push({ name: 'ExportPotentialService' });
          })
          .catch(() => {
            Constants.alert.fire('Сохранение', Constants.commonError, 'error');
          });
      },
      close() {
        this.$router.push({ name: 'ExportPotentialService' });
      },
    },
    setup: () => ({ v$: useVuelidate() }),
    validations() {
      return {};
    },
  };
</script>

<style lang="scss" scoped></style>
